module.exports = __webpack_public_path__ + "img/9.fa89fdd4.png";